import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import {
  selectors as commonSelectors,
  actions as commonActions,
} from 'shared/store'
import { isPoland } from 'shared/utils'
import { useGetCountryProperties } from './useGetCountryProperties'

const POLISH_VAT_RATE = 0.23

export const useVat = () => {
  const dispatch = useDispatch()
  const { getCountryCode } = useGetCountryProperties()
  const { data: companyData } = useSelector(
    commonSelectors.users.getCompanyDataState
  )

  const isPolish = isPoland(getCountryCode(companyData?.countryId) as string)

  useEffect(() => {
    dispatch(commonActions.users.getCompanyInfo({ disableRefetch: true }))
  }, [dispatch])

  const getPriceWithVat = (price?: number) => {
    if (!price) return 0
    return parseFloat(
      (isPolish ? price + price * POLISH_VAT_RATE : price).toFixed(2)
    )
  }

  return getPriceWithVat
}
